import type { Input } from '@builder.io/sdk';

const splitContentFields = [
  {
    name: 'heading',
    type: 'richText',
  },
  {
    name: 'callToAction',
    type: 'object',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'url',
        type: 'url',
      },
    ],
  },
  {
    name: 'initialSide',
    type: 'object',
    subFields: [
      {
        name: 'eyebrowHtmlTag',
        type: 'string',
        enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        defaultValue: 'h3',
        helperText: 'Select the HTML heading tag for the eyebrow',
      },
      {
        name: 'eyebrow',
        type: 'string',
      },
      {
        name: 'callToActions',
        type: 'list',
        subFields: [
          {
            name: 'callToAction',
            type: 'object',
            subFields: [
              {
                name: 'label',
                type: 'string',
              },
              {
                name: 'url',
                type: 'url',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: 'details',
    type: 'richText',
  },
  {
    name: 'detailCallToActions',
    type: 'list',
    subFields: [
      {
        name: 'callToAction',
        type: 'object',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'url',
            type: 'url',
          },
          {
            name: 'types',
            type: 'string',
            enum: ['button', 'arrow'],
          },
        ],
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const splitContentConfig = {
  name: 'Split Content',
  inputs: splitContentFields,
};

export type SplitContentProps = GenerateBuilder<typeof splitContentFields>;

export default splitContentConfig;
